'use client';

import React from 'react';
import { Card } from '../../../components/ui/card';
import { Button } from '../../../components/ui/button';
import { Trash2 } from 'lucide-react';

interface DeleteEventModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  eventTitle?: string;
  isLoading?: boolean;
}

export const DeleteEventModal: React.FC<DeleteEventModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  eventTitle,
  isLoading = false
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/60 flex items-center justify-center z-50">
      <Card className="w-full max-w-md mx-4 p-6">
        <div className="flex flex-col items-center text-center">
          {/* Icon */}
          <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mb-4">
            <Trash2 className="w-8 h-8 text-gray-600" />
          </div>

          {/* Title */}
          <h2 className="text-2xl font-bold text-gray-900 mb-2">
            Delete event
          </h2>

          {/* Description */}
          <p className="text-gray-600 mb-6 leading-relaxed">
            We will notify your guests about the cancellation of the event
            {eventTitle && (
              <span className="font-medium text-gray-900"> "{eventTitle}"</span>
            )}
          </p>

          {/* Action Buttons */}
          <div className="w-full space-y-3">
            <Button
              onClick={onConfirm}
              disabled={isLoading}
              className="w-full bg-accent text-white hover:bg-accent/90 py-3"
            >
              {isLoading ? 'Deleting...' : 'Delete'}
            </Button>
            
            <Button
              variant="outline"
              onClick={onClose}
              disabled={isLoading}
              className="w-full py-3"
            >
              Cancel
            </Button>
          </div>
        </div>
      </Card>
    </div>
  );
};